// 3rd
import { Model } from '@vuex-orm/core'

export default class StaticPage extends Model {
    static entity = 'static-pages';

    static fields() {
        return {
            id: this.attr(null),
            hero_image: this.attr(null),
            content: this.attr(null),
            slug: this.attr(null),
            title: this.attr(null),
            gallery: this.attr(null),
            custom_gallery_headline: this.attr(null),
            custom_downloads_headline: this.attr(null),
            downloads: this.attr(null),
        }
    }

    // getters
    static getBySlug(slug) {
        return StaticPage.query().where('slug', slug).first();
    }
}
